export class Model {
  constructor(difference) {
    this.width = 1200
    this.height = 280
    this.top = 0
    this.left = 0
    this.innerElement = "cxDanmaku"
    this.rowLen = 3
    // 背景
    this.bgColor = "#87CEFA"
    this.bgIsThemeColor = false
    this.background = []
    // 边框
    this.showBorder = false
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderTopRightRadius = 0
    this.borderTopLeftRadius = 0
    this.borderWidth = 0
    this.borderColor = "#3D82F2"
    this.borderStyle = "solid"
    this.borderIsThemeColor = false
    // 透明度
    this.opacity = 100
    // 阴影
    this.boxShadowColor = ["rgba(0,0,0,0.25)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    // 速度
    this.speeds = 100
    // 默认数据
    this.danmuDatas = [
      { name: "不舍青春，再见大学！", link: "" },
      { name: "感谢四年的陪伴，愿你前程似锦！", link: "" },
      { name: "愿我们都能勇敢追梦！", link: "" },
      { name: "毕业了，希望未来的日子更加精彩！", link: "" },
      { name: "愿大家在未来的路上越走越远！", link: "" },
      { name: "愿我们在未来的路上越走越远！", link: "" },
      { name: "不舍的分别，珍重再见！", link: "" },
      { name: "毕业了，愿我们都能实现自己的梦想！", link: "" },
      { name: "愿我们都能在新的旅程中熠熠生辉！", link: "" },
      { name: "新的开始，愿你我都能勇敢前行！", link: "" },
      { name: "愿我们不负青春，勇敢追梦！", link: "" },
      { name: "不说再见，期待未来的相遇！", link: "" },
      { name: "四年时光，转瞬即逝！", link: "" },
      { name: "感谢大家的陪伴与支持！", link: "" },
      { name: "毕业了，愿我们都能实现自己的梦想！", link: "" },
      { name: "愿我们未来的日子更加灿烂！", link: "" },
      { name: "毕业季，愿大家一切顺利！", link: "" },
      { name: "愿我们在未来的旅程中一切顺利！", link: "" },
      { name: "毕业了，愿大家的未来都充满光明！", link: "" },
      { name: "青春不散场，友谊永不变！", link: "" }
    ]
    // 文本
    this.widthAuto = true // 宽度 固定和自适应
    this.textWidth = 300
    this.heightAuto = false // 高度 固定和自适应
    this.textHeight = 60
    this.fontFamily = "sans-serif"
    this.textIsThemeColor = false
    this.fontSize = 20
    this.fontWeight = "400"
    this.color = "rgba(102, 102, 102, 1)"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.textDecoration = "none"
    this.textIndent = 0
    this.lineHeight = 60
    this.lineHeightType = "px"
    this.textLimitCount = 10
    // 文本边框
    this.showTextBorder = false
    this.textBorderTypeFlag = 2
    this.textBorderRadius = 102
    this.textBorderBottomLeftRadius = 102
    this.textBorderBottomRightRadius = 102
    this.textBorderTopRightRadius = 102
    this.textBorderTopLeftRadius = 102
    this.textBorderWidth = 0
    this.textBorderColor = "#3D82F2"
    this.textBorderStyle = "solid"
    this.textBorderIsThemeColor = false
    // 文本边距
    this.textPaddingTypeFlag = 2
    this.textPadding = 0
    this.textPaddingTop = 0
    this.textPaddingRight = 20
    this.textPaddingBottom = 0
    this.textPaddingLeft = 20
    // 文本透明度
    this.textOpacity = 100
    // 文本阴影
    this.textBoxShadowColor = ["rgba(0,0,0,0.25)"]
    this.textBoxShadowH = [0]
    this.textBoxShadowV = [0]
    this.textBoxShadowBlur = [0]
    this.textBoxShadowSpread = [0]
    // 滚动词云颜色
    this.colorList = ["#F0EBCB", "#BDECFF", "#CBE2FE"]

    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
